<template>
  <div class="bg">
    <div class="container">
      <div class="content">
        <h1 class="titles">{{ newsDetail.newsTitle }}</h1>
        <div class="detail-body" v-html="newsDetail.newsContent"></div>
        <div>
          <H1 class="filetitle">附件</H1>

          <div class="ansnsCon">
            <!-- <p class="ansns" @click="deait(item.url)"> {{ item.url }}</p> -->

            <p
              class="anasj"
              v-for="item in annex"
              :key="item.attachmentId"
              @click="deait(item.url)"
            >
              <img src="@/assets/image/FILE.png" />
              <el-link type="primary" class="title"> {{ item.name }}</el-link>
            </p>
          </div>
        </div>
      </div>

      <div class="lasttt">
        <div v-show="lasttitle">
          上一篇：<span style="cursor: pointer" @click="tolastpath"
            >{{ lasttitle ? lasttitle : "" }}
          </span>
        </div>
        <div v-show="nexttitle">
          <span
            >下一篇：<span style="cursor: pointer" @click="tonextpath"
              >{{ nexttitle ? nexttitle : "" }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  inject: ["reload"],
  name: "index",
  data() {
    return {
      newsDetail: {},
      newsList: [],
      nexttitle: "",
      nextid: "",
      lastid: "",
      lasttitle: "",
      annex: [],
    };
  },
  mounted() {
    this.getNews(this.$route.query.id);
    this.getannex(this.$route.query.id);
  },
  methods: {
    clickReload() {
      // 点击之后强制刷新
      this.reload();
    },
    tolastpath() {
      this.$router.push({
        path: "/news",
        query: { id: this.lastid, tagId: this.$route.query.tagId },
      });
      this.clickReload();
    },
    tonextpath() {
      this.$router.push({
        path: "/news",
        query: { id: this.nextid, tagId: this.$route.query.tagId },
      });
      this.clickReload();
    },
    getNews(id) {
      api.newsDetail(id).then((res) => {
        this.newsDetail = res.data;
      });
    },
    getannex(id) {
      api.queryByNewsId(id).then((res) => {
        console.log(res, "wi是得到的附件消息");
        // this.newsDetail = res.data;
        this.annex = res.data;
      });
    },
    get_tagnews() {
      if (this.$route.query.tagId) {
        api.newsForTag(this.$route.query.tagId, 0, 0).then((res) => {
          this.newsList = res.data;
          // console.log(this.newsList)
          res.data.list.map((item, inx) => {
            console.log(inx);
            console.log(res.data.length);
            if (item.newsId == this.$route.query.id) {
              if (inx == 0) {
                this.lastid = null;
                this.lasttitle = null;
                this.nextid = res.data.list[inx + 1].newsId;
                this.nexttitle = res.data.list[inx + 1].newsTitle;
              } else if (inx == res.data.list.length - 1) {
                this.nexttitle = null;
                this.nextid = null;
                this.lastid = res.data.list[inx - 1].newsId;
                this.lasttitle = res.data.list[inx - 1].newsTitle;
              } else {
                this.nextid = res.data.list[inx + 1].newsId;
                this.nexttitle = res.data.list[inx + 1].newsTitle;
                this.lastid = res.data.list[inx - 1].newsId;
                this.lasttitle = res.data.list[inx - 1].newsTitle;
              }
            }
          });
        });
      }
    },
    // 查看附件
    deait(url) {
      window.open(url);
    },
  },
  created() {
    // $router.push({path: '/news',query: {id: itm.newsId,tagId:newsActive}})
    this.get_tagnews();
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content {
  margin-top: 20px;
  background: #ffffff;
  padding: 10px 20px;
  .titles {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 50px;
    text-align: center;
    font-style: normal;
    padding: 10px 0px;
    border-bottom: 1.5px solid #f5f5f6;
    margin: 0px;
  }
}

.filetitle {
  height: 22px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
}
.ansnsCon {
  // display: flex;

  .ansns {
    color: #264f99;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
  }

  .anasj {
    cursor: pointer;
    margin: 0px;
    color: #264f99;
    display: flex;
    align-items: center;

    .title {
      margin-left: 10px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 14px;
      line-height: 26px;
      text-align: justify;
      font-style: normal;
      color: #264f99 !important;
    }
  }
}

.lasttt {
  height: 22px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  padding: 20px 0px;
}





</style>


<style lang="scss">
.detail-body{
  img{
    width: 100%;
  }
}
</style>
